import React from 'react';
import { SelectBox } from './SelectBox';

export const SectionSelectBox = ({ sections, selectedSectionNumber, onSectionChanged }) => {
    if (!sections) {
        return null;
    }

    if (!sections.length) {
        return <p>No sections found for the manufacturer.</p>
    }

    const selectedValue = selectedSectionNumber || sections[0].number;
    return (
        <SelectBox
            items={sections}
            selectedValue={selectedValue}
            onSelectionChanged={onSectionChanged}
            itemTextSelector={section => `${section.number} - ${section.name}`}
            itemValueSelector={section => section.number}
        />
    )
}